var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",value:({
    title: _vm.tooltipTitle,
    html: true,
    disabled: _vm.disabled,
  }),expression:"{\n    title: tooltipTitle,\n    html: true,\n    disabled: disabled,\n  }",modifiers:{"hover":true}}],class:_vm.badgeClass,attrs:{"variant":_vm.variant}},[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }